import React, { Component } from "react";

import { AuthContext } from "./AuthProvider";
import ExternalLoginService from "../services/ExternalLoginService";
import Error from "../helpers/Error";
import LoaderSpinner from "../helpers/LoaderSpinner";
import { withStyles } from "@material-ui/core";

//TODO: Translations are not yet loaded, so the message is fixed in pt-BR
const errors = {
  title: "Não conseguimos carregar este conteúdo",
  subtitle:
    "Encontramos uma instabilidade interna. Tente novamente em instantes.",
  action: "Tentar novamente",
};

const styles = (theme) => ({
  centerContainer: {
    width: "100%",
    height: "550px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

class AuthEmbeddedProvider extends Component {
  authService = new ExternalLoginService();
  state = {
    loading: true,
    error: false,
    message: "",
    isAuthenticated: false,
  };

  componentDidMount() {
    this.authServiceStart();
  }

  authServiceStart() {
    this.authService
      .serviceStart()
      .then((authenticated) => {
        if (authenticated) return this.setIsAuthenticated();

        this.setError();
      })
      .catch((error) => this.setError());
  }

  sendEventReload() {
    window.parent.postMessage({ authEmbeddedError: true }, "*");
  }

  setIsAuthenticated() {
    this.setState({ loading: false, error: false, isAuthenticated: true });
  }

  setError() {
    this.setState({
      loading: false,
      error: true,
      message: "Usuário não autenticado",
    });
  }

  render() {
    const { children, classes } = this.props;
    const { isAuthenticated, error, loading } = this.state;

    return (
      <AuthContext.Provider value={this.authService}>
        {(loading || error) && (
          <div className={classes.centerContainer}>
            {loading && <LoaderSpinner />}

            {error && (
              <Error
                title={errors.title}
                subtitle={errors.subtitle}
                actionLabel={errors.action}
                action={() => this.sendEventReload()}
              />
            )}
          </div>
        )}
        {isAuthenticated && children}
      </AuthContext.Provider>
    );
  }
}

export default withStyles(styles)(AuthEmbeddedProvider);
